import { render, staticRenderFns } from "./CustomerPanel.vue?vue&type=template&id=75318d45"
import script from "./CustomerPanel.vue?vue&type=script&lang=js"
export * from "./CustomerPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports